// Copyright (c) StrangeBee 2024

import { classList } from '@Helpers/className';
import { Collapse, CollapsePanelProps } from 'antd';
import React from 'react';

import './Panel.scss';

type PanelProps = CollapsePanelProps;

export const Panel = ({ className, ...props }: PanelProps) => (
    <Collapse.Panel className={classList('th-collapse__panel', className)} {...props} />
);
